import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-subject-search-dialog',
  templateUrl: './subject-search-dialog.component.html',
})
export class SubjectSearchDialogComponent {

  form: FormGroup;

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<SubjectSearchDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.form = this.fb.group({
      name: [data?.name ?? ''],
      surname: [data?.surname ?? ''],
      legalEntity: [data?.legalEntity ?? ''],
      telephone1: [data?.telephone1 ?? ''],
      telephone2: [data?.telephone2 ?? ''],
      email: [data?.email ?? ''],
      streetName: [data?.streetName ?? ''],
      city: [data?.city ?? ''],
      state: [data?.state ?? ''],
      responsible: [data?.responsible ?? ''],
    });
  }

  search(): void {
    this.dialogRef.close(this.form.value);
  }

  cancel(): void {
    this.dialogRef.close(null);
  }
}
